/**
 * The bearer token every Flow Studio request sends. This is the single place that reads it, so the base
 * client, the lookup wrappers and the pinned-snapshot fetch cannot drift onto different token sources.
 * Returns null when no token is stored or when storage is unavailable (for example blocked site data).
 */
export function getAuthToken(): string | null {
  try {
    return localStorage.getItem('authToken');
  } catch {
    return null;
  }
}

/** Authorization header for a request, or an empty object when there is no token. */
export function authHeaders(): Record<string, string> {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
